import { Analytics } from './Analytics';

export default new Analytics(window.solar ? window.solar.analytics : 'solar-dev');
